import React, { useEffect, useState } from 'react'
import { Row, Col } from 'reactstrap'
import { Panel } from './../Dashboard/Panel'
import DashboardLayout from './../Dashboard/DashboardLayout'
import { columnsActions, columnsActionsExport, columnsOffence, columnsOffenceExport } from './columns'
import DataTable from './../Table/Table'

import axios from 'axios'

export const History = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    
    const [ startDate, setStartDate ] = useState('')
    const [ endDate, setEndDate ] = useState('')
    const [ error, setError ] = useState('')

    const [ historyOffence, setHistoryOffence ] = useState([])
    const [ historyActions, setHistoryActions ] = useState([])


	async function requestHistoryOffence() {
		const result = await axios.post('/api/history/historyOffence', {
			startDate,
			endDate,
		})
		const data = result.data
		setHistoryOffence(data)
	}
    async function requestHistoryActions() {
		const result = await axios.post('/api/history/historyActions', {
			startDate,
			endDate,
		})
		const data = result.data
		setHistoryActions(data)
	}

    useEffect(() => {
        async function init() {
            await requestHistoryOffence()
            await requestHistoryActions()
        }
        init()
    }, [])


    async function handleOnSubmit(event) {
        event.preventDefault()

        if (Date.parse(startDate) > Date.parse(endDate)) {
            //start is less than End
            setError('La fecha de inicio debe ser menor a la de fin.')
            return
        }

        setError('')
        await requestHistoryOffence()
        await requestHistoryActions()
    }

    const [ clear, setClear ] = useState(false)
    function handleClickClear() {
        setStartDate('')
        setEndDate('')
        setClear(true)
    }

    async function handleClickRefresh() {
        await requestHistoryOffence()
        await requestHistoryActions()
        setClear(false)
    }

    return (
        <DashboardLayout>
            <Row>
                <Col className="d-flex flex-row align-items-center">
                    <form onSubmit={handleOnSubmit}>
                        <ul className="list-inline">
                            <li className="list-inline-item">
                                <div className="input-group">
                                    <input
                                        type="date"
                                        name="startDate"
                                        className="form-control border-0"
                                        value={startDate}
                                        onChange={(event) => setStartDate(event.target.value)}
                                    />
                                    <input
                                        type="date"
                                        name="endDate"
                                        className="form-control  border-0"
                                        value={endDate}
                                        onChange={(event) => setEndDate(event.target.value)}
                                    />
                                    <div style={{ marginLeft: '10px' }}>
                                        <button className="btn btn-primary" type="submit">
                                            <i className="fas fa-search fa-sm" />
                                        </button>
                                    </div>
                                    {(startDate || endDate) && (
                                        <div style={{ marginLeft: '10px' }}>
                                            <button className="btn btn-primary" onClick={handleClickClear}>
                                                Clean Fields
                                            </button>
                                        </div>
                                    )}
                                    {clear && (
                                        <div style={{ marginLeft: '10px' }}>
                                            <button className="btn btn-primary" onClick={handleClickRefresh}>
                                                Start
                                            </button>
                                        </div>
                                    )}
                                    {error && (
                                        <p style={{ margin: '5px' }} className="text-danger">
                                            {error}
                                        </p>
                                    )}
                                </div>
                            </li>
                        </ul>
                    </form>
                </Col>
            </Row>

            <br />
            {''}
            <Row>
				<Col xl="12" lg="12">
					<Panel title="History Offence Detail" enableExport columnsToExport={columnsOffenceExport} data={historyOffence} tableName='History Offence Detail'>
						<DataTable data={historyOffence} structure={columnsOffence} tableName="History Detail Offence" />
					</Panel>
				</Col>
            </Row>
            <Row>
				<Col xl="12" lg="12">
					<Panel title="History Actions Detail" enableExport columnsToExport={columnsActionsExport} data={historyActions} tableName='History Actions Detail'>
						<DataTable data={historyActions} structure={columnsActions} tableName="History Detail Actions" />
					</Panel>
				</Col>
            </Row>
        </DashboardLayout>
    )
}

export default History